<ep-view>
  <div class="ep-padding-10">
    <ep-splitter orientation="horizontal">
      <ep-splitter-pane [collapsible]="true" size="20%" [min]="20" [scrollable]="false">
        <div class="ep-pad-all-20">
          <ep-tab-strip (epOnTabSelect)="onTabSelect($event)" [model]="tabModel" style="padding: 0px">
          </ep-tab-strip>
        </div>
      </ep-splitter-pane>

      <ng-template #tabTemplate>
        <div class="horiz">
          <ep-combo-box [labelText]="'Company'" (epOnValueChange)="changeCompany($event)" [data]="companies"
            [(ngModel)]="companyId" [hidden]="companyComboHidden()"></ep-combo-box>
          <ep-search-box title="" (epOnValueChange)="searchMethod($event)" [(ngModel)]="currentSearch" name="searchBox"
            ngDefaultControl></ep-search-box>
          <ep-combo-box [labelText]="'API Version'" [data]="versions" [(ngModel)]="version"
            [hidden]="versionComboHidden()" (epOnValueChange)="changeVersion($event)"></ep-combo-box>
        </div>
        <div class="ep-single-list" #list>
          <ep-selection-list id="methods" [model]="panelListModel" (epOnListItemClick)="showHelpUI($event)">
          </ep-selection-list>
        </div>
      </ng-template>

      <ep-splitter-pane [collapsible]="true" [scrollable]="true">
        <ep-tool-bar [model]="toolBarModel"></ep-tool-bar>
        <ng-template #toolbarTemplate let-model="model" let-item="item">
          <h3>Set Call Headers</h3>
          <ep-chip-select [model]="headersChips" [(ngModel)]="selectedHeaders">
          </ep-chip-select>
        </ng-template>
        <h3 class="ep-pad-all-20 selectItemWarning" *ngIf="shouldShowSelectItemMessage()">{{selectItemMessage()}}</h3>
        <div #helpui>
          <div *ngIf="shouldShowLinks()" class="ep-align-hright">
            <span>
              <span *ngIf="shouldUseExtensions() | async; else swaggerLink">
                <a [href]="getOpenApiDocLinkWithExt('json')" class="ep-pad-all-10" target="_blank"> Open JSON document
                  <i class="mdi mdi-open-in-new"></i> </a>
                <a [href]="getOpenApiDocLinkWithExt('yaml')" class="ep-pad-all-10" target="_blank"> Open YAML document
                  <i class="mdi mdi-open-in-new"></i> </a>
              </span>
              <ng-template #swaggerLink>
                <a [href]="getSwaggerDocLink()" class="ep-pad-all-10" target="_blank"> Open Swagger document <i
                    class="mdi mdi-open-in-new"></i> </a>
              </ng-template>
              <a [href]="getLegacyHelpPageLink()" class="ep-pad-all-10" target="_blank"> Go to old help page <i
                  class="mdi mdi-open-in-new"></i> </a>
            </span>
          </div>

          <div id="swagger-ui"></div>
        </div>
      </ep-splitter-pane>
    </ep-splitter>
  </div>
</ep-view>
